import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ROUTE_PATHS } from '../../utils/route-paths.const';

/**
 * Blocks the restricted units page when the investor has none.
 * The count is handed over in navigation state by the summary card, so a
 * direct/refreshed hit (no state) is treated as "no restricted units" and
 * bounced back to the fund.
 */
export const restrictedUnitsGuard: CanActivateFn = (route): boolean => {
  const router = inject(Router);

  const count = router.currentNavigation()?.extras.state?.['restrictedUnits'];
  if (typeof count === 'number' && count > 0) return true;

  const id = route.paramMap.get('id');
  router.navigate(id ? [ROUTE_PATHS.FUNDS, id] : [ROUTE_PATHS.HOME], {
    replaceUrl: true,
    state: { bypassGuard: true },
  });
  return false;
};
